import React from 'react';

/**
 * 全局错误边界：任何子页面渲染时抛错，不再让 React 卸载整棵树变白屏（用户只能大退重进），
 * 而是显示一个可恢复的出错页（返回首页 / 重新加载）。同时把真实错误记录下来便于定位。
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // 记录真实报错（控制台 + 后端日志接口若有）。生产可在此上报。
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] 页面渲染出错:', error, info?.componentStack);
    try {
      const payload = {
        msg: String(error?.message || error),
        stack: String(error?.stack || '').slice(0, 2000),
        path: window.location?.pathname + window.location?.search,
        ua: navigator.userAgent,
      };
      // 静默上报（后端没有该接口也不影响）
      navigator.sendBeacon?.('/api/system/client-error', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    } catch (_) {}
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: '60vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', padding: '40px 24px',
        textAlign: 'center', color: '#6B5840', background: '#FAF8F5',
      }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>😵</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#1A1410', marginBottom: 6 }}>页面出错了</div>
        <div style={{ fontSize: 13, color: '#A89070', marginBottom: 24, maxWidth: 320, lineHeight: 1.7 }}>
          这个页面加载时遇到问题，你可以返回上一页或回首页重试。<br />（不用大退重进）
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={() => { this.handleReset(); if (window.history.length > 1) window.history.back(); else window.location.href = '/'; }}
            style={{ padding: '10px 22px', borderRadius: 8, border: '1px solid #DDD7CC', background: '#fff', color: '#6B5840', fontSize: 14, cursor: 'pointer' }}
          >返回上一页</button>
          <button
            onClick={() => { this.handleReset(); window.location.href = '/'; }}
            style={{ padding: '10px 22px', borderRadius: 8, border: 'none', background: '#B8892A', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
          >回首页</button>
        </div>
        {/* 错误详情（可截图反馈给客服，便于定位修复） */}
        <details style={{ marginTop: 22, maxWidth: 340, width: '100%' }}>
          <summary style={{ fontSize: 12, color: '#A89070', cursor: 'pointer' }}>错误详情（可截图反馈）</summary>
          <pre style={{
            marginTop: 8, padding: '10px 12px', background: '#F4F1EB', borderRadius: 6,
            fontSize: 11, color: '#9B2335', whiteSpace: 'pre-wrap', wordBreak: 'break-all', textAlign: 'left',
          }}>{String(this.state.error?.message || this.state.error || '未知错误')}</pre>
        </details>
      </div>
    );
  }
}
